import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import cal from "../../cal.png";
import calw from "../../calw.png";
import goclose2 from "../../goclose2.png";
import gopresent from "../../gopresent.png";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

 
import KidNew from "./KidNew";
import GroupEdit from "./GroupEdit";

import icoArrow from '../../Down_Arrow_3_.png'



import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import KidEdit from "./KidEdit";
import KidDelete from "./KidDelete";
import KidsMove from "./KidsMove";

import Start from "./Start";
import QuickChat from "../msg/QuickChat";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
import KidDeleteMass from "./KidDeleteMass";
import AppContext from "../../AppContext";
import KidsImport from "./KidsImport";
import KidPersons from "./KidPersons";


function Kids(props)
{
    

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),
        r_imie_nazwisko:  props.mainView.readFilter('r_imie_nazwisko',''), 
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        archiwalne: props.mainView.readFilter('archiwalne','0'),

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    const [optionTakNie, setOptionTakNie]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Nie'
        }, {
            v: '1',
            title: 'Tak'
        }
    ]
    );
    



    
    const tabRef = useRef(0); //do druku


    var defView =  {
        v:'list',
        id: -1
    } ;

    if(props.mainView.idSelected == -2)
    {
        defView =  {
            v:'new',
            id: -1
        } ;
    }

    const [view, setView] = useState ( defView);

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'dziecko przeniesione do archiwum',
            filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
        },
    ]);









    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------







    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,kids', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            


                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');
        props.mainView.writeFilter('r_imie_nazwisko', '');
        props.mainView.writeFilter('p_group_id', '_x_');
        props.mainView.writeFilter('archiwalne', '0');

        setFilterParam({ 
            d_imie_nazwisko: '', 
            r_imie_nazwisko: '',
            p_grupa_id: '_x_',
            archiwalne: 0,    
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },


            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }



   


    const goMove = () => {

        

        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
            return;              
         }

         setView({
            v:'move',
            id: -1,
         });

      

    }



    
    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }

   



    const goDelete = (e) => {



        var ids = new Array();
                
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnego dziecka' ,  "ok"  ,null); 
            return;              
         }

         setView({
            v:'delete_mass',
            id: -1,
         });

      

        
    }




   

    const goRestoreOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_kids,restore', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Dziecko zostało przywrócone" , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goRestore = (e) => {

        var id        = e.target.getAttribute("id");
        var imie      = e.target.getAttribute("imie");
        var nazwisko  = e.target.getAttribute("nazwisko");


        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz przywrócić dziecko z archiwum (" + imie + " " + nazwisko + ") ?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goRestoreOK(id);
                        //--------
        } );
    }
 

    
    const reviewKid = (e) =>
    {
        var id        = e.target.getAttribute("id");
        var imie      = e.target.getAttribute("imie");
        var nazwisko  = e.target.getAttribute("nazwisko");

        props.mainView.openKid( id, imie, nazwisko );
    }



    var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "dziecko_nazwisko", name: "Nazwisko"  },
        {column: "data_urodzenia", name: "Data urodzenia"  },
]

 

    var xwindow = null;
   


    if(view.v == 'new')
    {
        return <KidNew  userData={props.userData} mainView={props.mainView} onBack={onBack}   />
    }

    if(view.v == 'edit')
    {
        var searchRow = null;
        for(var k=0; k<tab.length; k++)
        {
            if(tab[k].id == view.id) { searchRow = tab[k]; break; }
        }

        return <KidEdit  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />
    }



    if(view.v == 'cal')
        {
            var searchRow = null;
            for(var k=0; k<tab.length; k++)
            {
                if(tab[k].id == view.id) { searchRow = tab[k]; break; }
            }
    
            return <Start  userData={props.userData} mainView={props.mainView} p_dziecko_id={searchRow.id} onBack={onBack}    />
        }


        if(view.v == 'calw')
            {
                var searchRow = null;
                for(var k=0; k<tab.length; k++)
                {
                    if(tab[k].id == view.id) { searchRow = tab[k]; break; }
                }
        

                xwindow = <div className="dlg_window dlg_type_90">
                                <div className="dlg_title">
                                      <img src={goclose2}  onClick={changeView} v="list" id={"-1"}  /> { searchRow.imie + " " + searchRow.nazwisko }
                                </div>
                                <div className="dlg_content_x">
                                        <Start  userData={props.userData} mainView={props.mainView} p_dziecko_id={searchRow.id} onBack={onBack}    />
                                </div>
                          
                </div>
 
            }

    
    if(view.v == 'delete')
        {
            var searchRow = null;
            for(var k=0; k<tab.length; k++)
            {
                if(tab[k].id == view.id) { searchRow = tab[k]; break; }
            }
    
            return <KidDelete  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />
        }


        if(view.v == 'delete_mass')
            {
                var ids = new Array();
 
                         
                for(var k=0; k<selectedRow.length; k++)
                    {
                            if( selectedRow[k].selected == 1)
                            {
                                    ids.push({
                                        id: selectedRow[k].id,
                                        title: selectedRow[k].title
                                    });
                            }
                    }
    
        
                return <KidDeleteMass  userData={props.userData} mainView={props.mainView} ids={ids} onBack={onBack}    />
            }


    if(view.v == 'move')
            {          
                 var ids = new Array();
 
                         
                 for(var k=0; k<selectedRow.length; k++)
                     {
                             if( selectedRow[k].selected == 1)
                             {
                                     ids.push({
                                         id: selectedRow[k].id,
                                         title: selectedRow[k].title
                                     });
                             }
                     }
     
     
                     return <KidsMove  userData={props.userData}  mainView={props.mainView} ids={ids} onBack={onBack} onSuccess={getTab}  />
            }  


    if(view.v == "import")
    {
        return <KidsImport  userData={props.userData} mainView={props.mainView}   onBack={onBack} onSuccess={onBack}   />

    }

 if(view.v == "persons")
    {

        var title = "";

        for(var k=0; k< tab.length; k++)
        {
            if(tab[k].id == view.id){
                    title = tab[k].nazwisko + " " + tab[k].imie;
                    break;
            }
        }

        return <KidPersons  userData={props.userData} mainView={props.mainView}   onBack={onBack} onSuccess={onBack} id={view.id}  title={title} />

    }

        var zaznaczonych = 0;
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) zaznaczonych ++;
        }

    

    return (

        <div className="view_content">

            {xwindow}

           
            {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
            } 

            {
                    filterParam.show == true  &&
                    <div className="table_filter">


                    <div className="filter_controll">   
                         <label>Grupa: </label>                             
                         <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                    </div> 

        
                    <div className="filter_controll">   
                         <label>Dziecko: </label>                             
                         <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                    </div>  

                    <div className="filter_controll">   
                         <label>Rodzic: </label>                             
                         <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                    </div> 
                   

                     <div className="filter_controll">   
                         <label>Archiwum: </label>                             
                         <InputCombo   userData={props.userData} value={filterParam.archiwalne} items={optionTakNie}  valChange={valChangeListener} goNext={goNextNew} name="archiwalne" placeholder={"Archiwalne: "}   />
                     </div> 

                     

                     <div className="filter_btn">
                         <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                         <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                     </div>

                </div>
            } 


         




            <div className="bg_center">


                    <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > nowe dziecko</div>

                              &nbsp;&nbsp;

                              <div className="btn" onClick={changeView} v="import" id="-1"  > import</div>

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                    </div>


                            <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                                    &nbsp;
                                    <span className="btn" onClick={goMove}  >Przenieś do placówki / grupy</span>   
                                    &nbsp;
                                    <span className="btn" onClick={goDelete}  >Usuń zaznaczone</span>                                                              
                            </div>

 

                    <div className="scorll_x">
                            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>   
                                                <td>LP</td>
                                                <td>SysID</td>  
                                                <td>Grupa</td>  
                                                <td>Nazwisko, imię</td>    
                                                <td>Data urodzenia</td>    
                                                <td>Rodzice</td>  
                                                <td className="td_right">Adres</td>                                       
                                                <td className="td_option"> </td>
                                                
                                          
                                              
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var cls = "";
                                                    if(row.archiwalne == '1') cls = "color_deleted";


                                                    var isChecked = "";

                                                    for(var s=0; s<selectedRow.length; s++)
                                                        {
                                                            if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                        }


                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle + cls}  key={ix+"r"} > 


                                                            <td className="gocenter ">
                                                                 <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                            </td>  

                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="gocenter">{row.id}</td>
                                                            <td className="link_normal"  onClick={changeView} v="edit" id={row.id}>
                                                                {row.grupa}
                                                                {
                                                                    row.grupy.length > 0 &&
                                                                    <Fragment>
                                                                        <br/>Inne: 
                                                                        {
                                                                            row.grupy.map(( ggg, gggInx ) => {

                                                                                    return <span>
                                                                                        &nbsp; {ggg.nazwa}
                                                                                    </span>

                                                                            })
                                                                        }
                                                                    </Fragment>
                                                                }
                                                            </td>
                                                            <td >
                                                                {row.nazwisko + " " + row.imie  }
                                                                &nbsp;                                                       
                                                                <img src={gopresent} id={row.id} imie={row.imie} nazwisko={row.nazwisko} onClick={reviewKid} title="podgląd"  />                                                           
                                                            </td>
                                                            <td  onClick={changeView} v="edit" id={row.id} className="link_normal gocenter" >
                                                                {
                                                                    row.data_urodzenia != '0000-00-00' && 
                                                                    <Fragment>{row.data_urodzenia}</Fragment>
                                                                }
                                                               
                                                            </td>
                                                            <td  onClick={changeView} v="edit" id={row.id} className="link_normal" >
                                                                { 
                                                                    row.rodzice.map( (rodz, rI) => {
                                                                        return <span>
                                                                                {    rodz.nazwisko + " " + rodz.imie + ", "}
                                                                               <QuickChat id={rodz.id}  title={rodz.imie +" " + rodz.nazwisko } mainView={props.mainView} userData={props.userData} /> 
                                                                               &nbsp;
                                                                        </span>
                                                                    } )
                                                                }
                                                            </td>
                                                            <td  onClick={changeView} v="edit" id={row.id} >{row.ulica + " " + row.nr_domu + "/" + row.nr_mieszkania + " " + row.kod_pocztowy + " " + row.miasto}</td>
                                                           
                                                    
                                                    
                             
                                                            <MenuTable>
                                                                        <ul>
                                                                            <li  onClick={changeView} v="calw" id={row.id}  >kalendarz</li>
                                                                            <li  onClick={changeView} v="edit" id={row.id}  >zmień dane</li>
                                                                            <li  onClick={changeView} v="persons" id={row.id}  >os. upoważnione</li>

                                                                            {
                                                                                row.archiwalne == 0 &&
                                                                                <li  onClick={changeView} v="delete" id={row.id}  >usuń</li>
                                                                            }

                                                                            {
                                                                                row.archiwalne == 1 &&
                                                                                <li  onClick={goRestore}  imie={row.imie} nazwisko={row.nazwisko} id={row.id}  >przywróć</li>
                                                                            }
                                                                       

                                                                        </ul>                                                               
                                                            </MenuTable>  

                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
                    </div>
            </div>


        </div>

    )

}


export default Kids;